import { ScrollReveal } from "./ScrollReveal";

export const VideoSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest">Wideo</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Zobacz nas w akcji
            </h2>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={200}>
          <div className="max-w-4xl mx-auto aspect-video rounded-2xl overflow-hidden shadow-2xl">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/Wjd8tuRphjw?controls=1&rel=0"
              title="Występ komediowy dla firm"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </div>
          <p className="text-center mt-8 text-muted-foreground max-w-2xl mx-auto">
            Każdy występ jest dostosowany do potrzeb Twojej firmy i charakteru wydarzenia. 
            Gwarantujemy profesjonalizm i świetną zabawę!
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
};
